import {
  AccountSettingsChangeTabEvent,
  AccountSettingsContactFormEvent,
  AccountSettingsDeleteAccountEvent,
  AccountSettingsDeleteCardEvent,
  AccountSettingsEditEvent,
  AccountSettingsReadFaqsEvent,
  AccountSettingsSaveEvent,
  AccountSettingsSaveNotificationsEvent,
  AccountSettingsSecurityToggleEvent,
  AccountSettingsToggleNotificationEvent,
} from '@interfaces/models/internal/analytics-event/account-settings-event';

export const accountSettingsEditEventPayload: Omit<AccountSettingsEditEvent, 'property'> = {
  event: 'my_account_edit',
  category: 'my_account',
  action: 'edit',
  label: 'account',
};

export const accountSettingsChangeTabEventPayload: Omit<AccountSettingsChangeTabEvent, 'label'> = {
  event: 'my_account_change_tab',
  category: 'my_account',
  action: 'change_tab',
};

export const accountSettingsSaveEventPayload: Omit<AccountSettingsSaveEvent, 'property'> = {
  event: 'my_account_save_changes',
  category: 'my_account',
  action: 'save_changes',
  label: 'account',
};

export const accountSettingsReadFaqsEventPayload: AccountSettingsReadFaqsEvent = {
  event: 'my_account_read_faqs',
  category: 'my_account',
  action: 'read_faqs',
  label: 'account',
};

export const accountSettingsDeleteAccountEventPayload: AccountSettingsDeleteAccountEvent = {
  event: 'my_account_delete_account',
  category: 'my_account',
  action: 'delete_account',
  label: 'account',
};

export const accountSettingsContactFormEventPayload: Omit<AccountSettingsContactFormEvent, 'property'> = {
  event: 'my_account_contact_form',
  category: 'my_account',
  action: 'contact_form',
  label: 'account',
};

export const accountSettingsSaveNotificationsEventPayload: AccountSettingsSaveNotificationsEvent = {
  event: 'my_account_save_preferences',
  category: 'my_account',
  action: 'save_preferences',
  label: 'email-preferences',
};

export const accountSettingsToggleNotificationEventPayload: Omit<
  AccountSettingsToggleNotificationEvent,
  'event' | 'action' | 'property'
> = {
  category: 'my_account',
  label: 'email-preferences',
};

export const accountSettingsDeleteCardEventPayload: AccountSettingsDeleteCardEvent = {
  event: 'my_account_delete_card',
  category: 'my_account',
  action: 'delete_card',
  label: 'payment-methods',
};

export const accountSettingsSecurityToggleEventPayload: Omit<AccountSettingsSecurityToggleEvent, 'property'> = {
  event: 'my_account_security_options',
  category: 'my_account',
  action: 'security_options',
  label: 'payment-methods',
};
